<template>
  <div class="WithSidebar">
    <div class="sidebar">
      <slot name="sidebar" />
    </div>
    <div class="slot">
      <slot />
    </div>
  </div>
</template>

<style scoped>

.sidebar + .slot {
  margin-top: var(--spacing-12);
}

@media (--screen-lg) {
  .WithSidebar {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 3fr);
    gap: var(--spacing-8);
  }
  .sidebar + .slot {
    margin-top: 0;
  }
}
</style>
